import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { arrow11 as arrow } from "./dependencies.js";
import { cdn } from "./require.js"; // Returns true if the vaue is an Apache Arrow table. This uses a “duck” test
// (instead of strict instanceof) because we want it to work with a range of
// Apache Arrow versions at least 7.0.0 or above.
// https://arrow.apache.org/docs/7.0/js/classes/Arrow_dom.Table.html

export function isArrowTable(value) {
  return value && typeof value.getChild === "function" && typeof value.toArray === "function" && value.schema && Array.isArray(value.schema.fields);
}
export function getArrowTableSchema(table) {
  return table.schema.fields.map(getArrowFieldSchema);
}

function getArrowFieldSchema(field) {
  return {
    name: field.name,
    type: getArrowType(field.type),
    nullable: field.nullable,
    databaseType: String(field.type)
  };
} // https://github.com/apache/arrow/blob/89f9a0948961f6e94f1ef5e4f310b707d22a3c11/js/src/enum.ts#L140-L141


function getArrowType(type) {
  switch (type.typeId) {
    case 2:
      // Int
      return "integer";

    case 3: // Float

    case 7:
      // Decimal
      return "number";

    case 4: // Binary

    case 15:
      // FixedSizeBinary
      return "buffer";

    case 5:
      // Utf8
      return "string";

    case 6:
      // Bool
      return "boolean";

    case 8: // Date

    case 9: // Time

    case 10:
      // Timestamp
      return "date";

    case 12: // List

    case 16:
      // FixedSizeList
      return "array";

    case 13: // Struct

    case 14:
      // Union
      return "object";

    case 11: // Interval

    case 17: // Map

    default:
      return "other";
  }
}

export function loadArrow() {
  return _loadArrow.apply(this, arguments);
}

function _loadArrow() {
  _loadArrow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import("".concat(cdn).concat(arrow.resolve()));

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadArrow.apply(this, arguments);
}